import vCrop from './vCrop';

export default class vImage {
  /**
   * This create the Image objet
   * @param  {Object} image A raw image object
   * @return {void}
   */
  constructor(ratio) {
    this.file = {};
    this.preview = '';
    this.jcrop = {};
    this.image = {};
    this.cropper = new vCrop(ratio);
    this.imageElement = {};
  }

  /**
   * Init with image data
   * @return {void}
   */
  init(image) {
    this.image = image;

    this.preview = this.originalPreview();

    this.jcrop = this.cropper.jcrop;
  }

  /**
   * Load all the dependencies needed for the crop
   * @param  {@change} event
   * @param  {HtmlDomElement} imageElement the <img> or <canva> element for display crop
   * @return {Promise}
   */
  load(event, imageElement) {
    return new Promise((resolve, reject) => {
      if (event.target.files.length === 0) {
        reject();
      }

      this.file = event.target.files[0];

      this.cropper.init(event);

      resolve(this.createPreview());
    });
  }

  /**
   * Unload the image
   * @return {void}
   */
  unload() {
    this.file = {};

    this.cropper = new vCrop(this.ratio);

    this.preview = `/${this.image.optimized}`;
  }

  /**
   * This create the preview of the image in base64
   * @param  {image} image The image file
   * @return {void}
   */
  createPreview() {
    const reader = new FileReader();

    reader.onload = () => {
      this.preview = reader.result;
    };

    reader.readAsDataURL(this.file);
  }

  /**
   * Validate the crop, create the cropped preview and update the crop datas
   * @return {[type]} [description]
   */
  validateCrop() {
    this.preview = this.cropper.getCroppedPreview();

    this.jcrop = this.cropper.getCroppedDatas();
  }

  /**
   * Check if th ecropper is loaded
   * @return {Promise} axios response
   */
  cropperExists() {
    return Object.keys(this.cropper.cropper).length != 0;
  }

  /**
   * Return an original preview for the display
   * @return {[type]} [description]
   */
  originalPreview() {
    if (Object.keys(this.image).length === 0) {
      return '/default.png';
    }
    return `/${this.image.optimized}`;
  }
}
